import React, { Fragment, useEffect, useState } from 'react'
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer
} from 'recharts';
import { H2, H5 } from '@blueprintjs/core'

const BarResults = ({ results }) => {

    const [oneTwelve, setOneTwelve] = useState(0)
    const [oneTen, setOneTen] = useState(0)
    const [oneEight, setOneEight] = useState(0)
    const [oneSix, setOneSix] = useState(0)
    const [oneFour, setOneFour] = useState(0)


    const [fiveTwelve, setFiveTwelve] = useState(0)
    const [fiveTen, setFiveTen] = useState(0)
    const [fiveEight, setFiveEight] = useState(0)
    const [fiveSix, setFiveSix] = useState(0)
    const [fiveFour, setFiveFour] = useState(0)

    useEffect(() => {

        let totalPointsI1 = 0
        results[0].results.forEach((res) => {
            totalPointsI1 = totalPointsI1 + res.points
        })

        const getPercentage1 = points => points / totalPointsI1 * 100

        let totalPointsI2 = 0
        results[1].results.forEach((res) => {
            totalPointsI2 = totalPointsI2 + res.points
        })
        const getPercentage2 = points => points / totalPointsI2 * 100

        results.forEach((result, i) => {
            if (result.sequenceContext === "Etage R+1") {
                result.results.forEach((res, i) => {
                    if (res.resource.attributes[0].quantity === "8") {
                        setOneTwelve(getPercentage1(parseInt(res.points)))
                    } else if (res.resource.attributes[0].quantity === "10") {
                        setOneTen(getPercentage1(parseInt(res.points)))
                    } else if (res.resource.attributes[0].quantity === "12.5") {
                        setOneEight(getPercentage1(parseInt(res.points)))
                    } else if (res.resource.attributes[0].quantity === "16.5") {
                        setOneSix(getPercentage1(parseInt(res.points)))
                    } else if (res.resource.attributes[0].quantity === "25") {
                        setOneFour(getPercentage1(parseInt(res.points)))
                    }
                })
            } else if (result.sequenceContext === "Etage R+5") {
                result.results.forEach((res, i) => {
                    if (res.resource.attributes[0].quantity === "8.5") {
                        setFiveTwelve(getPercentage2(parseInt(res.points)))
                    } else if (res.resource.attributes[0].quantity === "10") {
                        setFiveTen(getPercentage2(parseInt(res.points)))
                    } else if (res.resource.attributes[0].quantity === "12.5") {
                        setFiveEight(getPercentage2(parseInt(res.points)))
                    } else if (res.resource.attributes[0].quantity === "16.5") {
                        setFiveSix(getPercentage2(parseInt(res.points)))
                    } else if (res.resource.attributes[0].quantity === "25") {
                        setFiveFour(getPercentage2(parseInt(res.points)))
                    }
                })
            }
        })
    }, [results])

    const data = [
        { name: '1/12', "R+1": oneTwelve.toFixed(2), "R+5": fiveTwelve.toFixed(2) },
        { name: '1/10', "R+1": oneTen.toFixed(2), "R+5": fiveTen.toFixed(2) },
        { name: '1/8', "R+1": oneEight.toFixed(2), "R+5": fiveEight.toFixed(2) },
        { name: '1/6', "R+1": oneSix.toFixed(2), "R+5": fiveSix.toFixed(2) },
        { name: '1/4', "R+1": oneFour.toFixed(2), "R+5": fiveFour.toFixed(2) },
    ];

    return (
        <Fragment>
            <H2 className='text-center new-results'>Pourcentage des votes des participants selon l'indice d'ouverture à R+5 et R+1</H2>
            <div className='barChartContainer margin-top-large margin-bottom-large new-results'>
                <H5 className='title-results' style={{ width: '8%', height: '100%', diplay: 'flex', alignItems: 'center' }}>
                    Pourcentage de votes
                </H5>
                <ResponsiveContainer width="100%" height={500}>
                    <BarChart
                        width={800}
                        height={300}
                        data={data}
                        padding={{ bottom: 40 }}
                        margin={{
                            top: 5, right: 30, left: 20, bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" tick={{ fill: 'rgba(255, 255, 255, 0.938)' }} />
                        <YAxis domain={[0, 100]} interval={1} barSize={50} label="Votes % &emsp;&emsp;&emsp;" tick={{ fill: 'rgba(255, 255, 255, 0.938)' }} unit='%' />
                        <Tooltip formatter={(value) => {
                            return (`${value} %`)
                        }} />
                        <Bar dataKey="R+5" fill="#1F77B4" />
                        <Bar dataKey="R+1" fill="#FF7F0E" />
                    </BarChart>
                </ResponsiveContainer>
            </div>
            <H5 className='title-results text-center' style={{ marginLeft: '8%', marginBottom: '20px' }}>
                Indice d'ouverture
                </H5>
            <div style={{ display: 'flex', justifyContent: 'center', marginLeft: '8%', marginBottom: '20px' }}>
                <div className="legend" style={{ backgroundColor: "#1F77B4" }}>R+5</div>
                <div className="legend" style={{ backgroundColor: "#FF7F0E" }}>R+1</div>
            </div>
        </Fragment>
    )
}

export default BarResults
